import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import Login from './pages/Login';
import Register from './pages/Register';
import SensorList from './pages/SensorList';
import SensorDetail from './pages/SensorDetail';
//import Dashboard from './pages/Dashboard';
import ReportForm from './pages/ReportForm';
import SensorTypeSelector from './pages/SensorTypeSelector';
import SensoresPorTipo from './pages/SensoresPorTipo';
import SensorDashboard from './pages/SensorDashboard';
import ThermalMapping from "./pages/ThermalMapping";
import GpsDashboard from "./pages/GpsDashboard";
import ColdChainTracking from "./pages/ColdChainTracking";
import AdminUsuarios from './pages/AdminUsuarios';
import AuditTrailPage from "./pages/AuditTrailPage";
import Part11Page from "./pages/Part11Page";
import CalibrationAdmin from "./pages/CalibrationAdmin";
import InstallationModule from "./pages/InstallationModule";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/registro" element={<Register />} />
                    <Route path="/dashboard" element={<SensorList />} />
                    <Route path="/sensor" element={<SensorList />} />
                    <Route path="/sensor/:id" element={<SensorDetail />} />
                    <Route path="/report" element={<ReportForm />} /> 
                    <Route path="/seleccionar-tipo" element={<SensorTypeSelector />} />
                    <Route path="/sensores-por-tipo/:tipo" element={<SensoresPorTipo />} />
                    <Route path="/dashboard/:tipo" element={<SensorDashboard />} />
                    <Route path="/dashboard/MapeoTermico" element={<ThermalMapping />} />
                    <Route path="/dashboard/:type" element={<SensorDashboard />} />
                    <Route path="/report/:tipo" element={<ReportForm />} />
                    <Route path="/gps" element={<GpsDashboard />} />
                    <Route path="/tracking/:sensorId" element={<ColdChainTracking />} />
                    <Route path="/admin/usuarios" element={<AdminUsuarios />} />
                    <Route path="/admin/audit-trail" element={<AuditTrailPage />} />
                    <Route path="/admin/part11" element={<Part11Page />} />
                    <Route path="/admin/calibraciones" element={<CalibrationAdmin />} />
                    <Route path="/instalacion/:sensorId" element={<InstallationModule />} />    
            </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;


